var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "CreateMessage" }, [
      _c("div", { staticClass: "lds-ring" }, [
        _c("div"),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _c("div"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _c("p", [_vm._v("Please wait, saving document.")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }